/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartItemCTA_item$ref = any;
type CartItemImage_item$ref = any;
type CartItemPricing_item$ref = any;
type CartItemTitle_item$ref = any;
type CartQuantitySelect_item$ref = any;
type CartRemoveItemLink_portfolioItem$ref = any;
type ItemFolderWrapper_item$ref = any;
type ItemHeartWrapper_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItem_portfolioItem$ref: FragmentReference;
export type CartItem_portfolioItem = {|
  +item: ?{|
    +serviceId: ?string,
    +isNotListed: ?boolean,
    +isDeleted: ?boolean,
    +isInProcurement: ?boolean,
    +seller: ?{|
      +isClosed: ?boolean,
      +isPending: ?boolean,
      +isSuspended: ?boolean,
    |},
    +firstPhotoWebPath: ?string,
    +title: ?string,
    +displayInfo: ?{|
      +pricing: ?{|
        +showOnHold: ?boolean,
        +showSold: ?boolean,
      |}
    |},
    +$fragmentRefs: CartItemImage_item$ref & CartItemTitle_item$ref & CartItemPricing_item$ref & CartItemCTA_item$ref & ItemFolderWrapper_item$ref & ItemHeartWrapper_item$ref & CartQuantitySelect_item$ref,
  |},
  +$fragmentRefs: CartRemoveItemLink_portfolioItem$ref,
  +$refType: CartItem_portfolioItem$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "loadPortfolioData",
    "variableName": "loadPortfolioData",
    "type": null
  },
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": null
  }
];
return {
  "kind": "Fragment",
  "name": "CartItem_portfolioItem",
  "type": "PortfolioItemV2",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "loadPortfolioData",
      "type": "Boolean!",
      "defaultValue": true
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartRemoveItemLink_portfolioItem",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "item",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "serviceId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "CartItemImage_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "CartItemPricing_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "CartItemCTA_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "ItemFolderWrapper_item",
          "args": (v0/*: any*/)
        },
        {
          "kind": "FragmentSpread",
          "name": "ItemHeartWrapper_item",
          "args": (v0/*: any*/)
        },
        {
          "kind": "FragmentSpread",
          "name": "CartQuantitySelect_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "CartItemTitle_item",
          "args": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isNotListed",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isDeleted",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isInProcurement",
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "seller",
          "storageKey": null,
          "args": null,
          "concreteType": "Seller",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isClosed",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isPending",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isSuspended",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "firstPhotoWebPath",
          "args": [
            {
              "kind": "Literal",
              "name": "size",
              "value": "large",
              "type": "ImageVersionTypeName!"
            }
          ],
          "storageKey": "firstPhotoWebPath(size:\"large\")"
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "displayInfo",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId",
              "type": "String"
            },
            {
              "kind": "Literal",
              "name": "page",
              "value": "pdp",
              "type": "PageDisplayEnum"
            }
          ],
          "concreteType": "ItemDisplayInfo",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "pricing",
              "storageKey": null,
              "args": null,
              "concreteType": "PriceInfoDisplay",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "showOnHold",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "showSold",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '34eaaac0173de7e98cbf61dcede867b0';
module.exports = node;
